<div class="boolean-toggle-component" [ngClass]="{ 'disabled': disabled }">
    <span class="input-label" *ngIf="inputLabel">{{ inputLabel | translate }}</span>
    <mat-button-toggle-group id="{{idPrefix}}toggle_group"
                             [(ngModel)]="selectedValue"
                             class="dr-boolean-toggle"
                             [ngClass]="{'on-the-right': inputLabel }"
                             name="input-boolean-toggle"
                             aria-label="input-boolean-toggle"
                             [disabled]="disabled">
        <mat-button-toggle id="{{idPrefix}}true" value="true">{{ 'boolean_toggle.yes' | translate }}</mat-button-toggle>
        <mat-button-toggle id="{{idPrefix}}false" value="false">{{ 'boolean_toggle.no' | translate }}</mat-button-toggle>
        <mat-button-toggle id="{{idPrefix}}unknown" value="null">?</mat-button-toggle>
    </mat-button-toggle-group>
</div>


